'use client';

import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@andritzot/metris-web-ui/feedback/dialog';
import Link from 'next/link';

interface JiraEpicConflictDialogProps {
  open: boolean;
  existingEpicUrl: string;
  onCloneAnyway: () => void;
  onSkip: () => void;
}

export function JiraEpicConflictDialog({
  open,
  existingEpicUrl,
  onCloneAnyway,
  onSkip,
}: Readonly<JiraEpicConflictDialogProps>) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle title="Jira Epic Already Exists" />
      <DialogContent>
        <Typography variant="body2">
          An epic with this name already exists in Jira:{' '}
          <Link href={existingEpicUrl} target="_blank" rel="noopener noreferrer">
            {existingEpicUrl}
          </Link>
          .
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          Do you want to create a new epic anyway (the existing Jira link will be overwritten), or link to the existing
          epic and save the item without creating a new one?
        </Typography>
      </DialogContent>
      <DialogActions
        primaryAction={{ label: 'Clone anyway', onClick: onCloneAnyway }}
        secondaryAction={{ label: 'Link to Existing', onClick: onSkip }}
      />
    </Dialog>
  );
}
